import React from 'react';
import './Classes.css';
import { useContext, useEffect } from 'react';
import DataContext from '../context/DataContext';
const Safty = () => {
  const {setNavtrans} = useContext(DataContext);
  useEffect(() => {
    setNavtrans(false);
  });
  return (
    <article className='container'>
      <div className='about'style={{width:"40%",height:"400px",overflowY:"scroll"}}>
        <h1>الأمان</h1>
        <br/>
        <p></p>
        <br/>
      </div>
    </article>
  )
}
export default Safty;